import angular from 'angular';

//Config
import StocksGestionRapportActiviteConfig from './_config/stocks.gestion.rapport.activite.config';
import StocksGestionRapportActiviteRoutes from './_config/stocks.gestion.rapport.activite.routes';
import StocksGestionRapportActiviteSyntheseRoutes from './_config/stocks.gestion.rapport.activite.synthese.routes';

//Components
import StocksGestionRapportActivite from './components/stocks-gestion-rapport-activite';
import StocksGestionRapportActiviteSave from './components/stocks-gestion-rapport-activite-save';
import StocksGestionRapportActiviteSynthese from './components/stocks-gestion-rapport-activite-synthese';

//services
import StocksGestionRapportActiviteService from './services/stocks.gestion.rapport.activite.service';

const moduleName = 'app.massia.gestion.stocks.gestion.rapport.activite';

angular
	.module(moduleName, [])
	.config(StocksGestionRapportActiviteConfig)
	.config(StocksGestionRapportActiviteRoutes)
	.config(StocksGestionRapportActiviteSyntheseRoutes)
	.service('StocksGestionRapportActiviteService', StocksGestionRapportActiviteService)
	.component('stocksGestionRapportActivite', StocksGestionRapportActivite)
	.component('stocksGestionRapportActiviteSave', StocksGestionRapportActiviteSave)
	.component('stocksGestionRapportActiviteSynthese', StocksGestionRapportActiviteSynthese);

export default moduleName;
